export { default as api } from '../../api';
import * as _dateHelpers from './date';
export { _dateHelpers as dateHelpers };
import * as _validation from '../validation';
export { _validation as validation };
export const REVALIDATE_TIME_10_MINUTES = 600000;
export const testFunction = () => {
  console.log('Hi from common');
};